import React, { useEffect, useState } from 'react';
import { Container, Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import Lots from './Reporting/Lots';
import PackagingReport from './Reporting/PackagingReport';
import Qirs from './Reporting/QualityIncidentReports';
import GradedQualityReport from './Reporting/GradedQualityReport';
import { useHttpUtils } from '../Utilities/useHttpUtils';
import useAlert from '../Alerts/useAlert';
import { BusinessUnit } from '../Types/BusinessUnit';

function Reporting() {
    const { t } = useTranslation();
    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const [assignedBusinessUnits, setAssignedBusinessUnits] = useState<BusinessUnit[]>([]);

    useEffect(() => {
        fetchDataAuthenticated("api/v1/user/businessUnits", "GET")
            .then(async (response) => {
                if (response.ok) {
                    return response.json();
                }

                throw new Error(await response.json());
            })
            .then((data) => {
                setAssignedBusinessUnits(data);
            })
            .catch(error => {
                setAlert("danger", "Error", "Failed to save user preferences. " + error.message);
            });
    }, [fetchDataAuthenticated, setAlert]);

    return (
        <Container fluid>
            <Tabs defaultActiveKey="lots" id="reporting-tabs" className="tabs mt-3 mb-3" mountOnEnter={true} fill>
                <Tab eventKey="lots" title={t("Reporting.LotsTabTitle")}>
                    <Lots />
                </Tab>
                <Tab eventKey="qirs" title={t("Reporting.QIRsTabTitle")}>
                    <Qirs />
                </Tab>
                {assignedBusinessUnits.some(b => b.businessUnitType === "Package") && 
                    <Tab eventKey="lotpackaging" title="Packaging Report">
                        <PackagingReport/>
                    </Tab>
                }
                <Tab eventKey="qualityreport" title="Quality Report">
                    <GradedQualityReport />
                </Tab>
            </Tabs>
        </Container>
    );
}

export default Reporting;